import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { FillingStationModel } from '../../../api/fillingstation/fillingstation';
import { FillingStationService } from '../../../api/fillingstation/fillingstation.service';

import { CountryGroupService } from '../../../api/countrygroup/countrygroup.service';
import { CountryModel } from '../../../api/country/country';

import { dragDropSortableServiceFactory } from 'ng2-dnd';
import { ThrowStmt } from '@angular/compiler';
declare var $: any;
declare var jQuery: any;
declare var swal: any;
@Component({
    selector: 'fillingstation-page',
    templateUrl: './fillingstation.html'
})
export class FillingStationComponent implements OnInit {
    fillingstationList: FillingStationModel[];
    fillingstationissueList: FillingStationModel[];
    fillingstation : FillingStationModel;

    countryList: CountryModel[];

    id: string;
    i: number;
    uniqueid : string = "";
    name : string = "";
    address : string = "";
    latitude : number = null;
    longitude : number = null;
    status : string = "Active";
    message : string = "";

    filterstatus : string = "All";
    filterarea : string = "All";
    filtercountrycode : string = "All";

    isallselect : boolean = false;
    isallselectDisable : number = 0;
    filterissuestatus : string = "All";

    fillingS : any;

    areabindList : any;
    areaList : any;

    areaIUList : any;

    selectCountryCode : string = "";
    selectAreaId : string = "";

    selectPageLimit: string = "10";
    totalcounter: string = "0";

    pageIndex: number = 0;
    visiblePaginationBtn = false;
    totalPages: number = 0;
    numbers: any; // [0,1,2,3,4]
    isDirectSearch: boolean;

    progressPer :string = "0%";

    isPreviousBtnEnable: boolean = true;
    isNextBtnEnable: boolean = true;

    searchFillingStationContent : string = "";

    constructor(private countrygroupservice : CountryGroupService,private fillingstationService: FillingStationService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' ||  localStorage.getItem('type') == 'GENEROSITY')) {
            this.progressPer = "0%";
            this.selectPageLimit = "10";
            this.totalcounter = "0";
            this.selectAreaId = "";
            this.selectCountryCode = "";
            this.areaList = [];
            this.areabindList = [];
            this.filterstatus = "All";
            this.filterarea = "All";
            this.filtercountrycode = "All";
            this.searchFillingStationContent = "";
            this.initFillingStation();
        } else {
            this.router.navigate(['/']);
        }
    }
    initFillingStation() 
    {
        this.isDirectSearch = false;
        this.progressPer = "10%";
        this.countrygroupservice
            .allCountryList()
            .then(data => {
                this.progressPer = "20%";
                this.countryList = data
                this.filtercountrycode = "All";
                var rrData11 = {
                }
                this.fillingstationService
                    .arealist(rrData11)
                    .then(
                        data => {
                            this.progressPer = "25%";
                            this.areaList = data;
                            this.areabindList = data;
                            this.getpaginationData();
                        } 
                    );
            });
       
    }
    getpaginationData() {
        this.fillingstationService.paginationList(this.filterstatus,this.filtercountrycode, this.filterarea).then(dd => {
          this.progressPer = "35%";
          this.totalcounter = dd.totalcounter;
          this.managepagination();
          this.getUsers();
        })
    }
    pageNext() {
        this.isDirectSearch = false;
        if (this.totalPages - 1 > this.pageIndex) {
            this.pageIndex = this.pageIndex + 1;
            this.getUsers();
            this.managepagination();
        }
    }
    pagePrevious() {
        this.isDirectSearch = false;
        if (this.pageIndex == 0) {
            return;
        }
        this.pageIndex = this.pageIndex - 1;
        this.getUsers();
        this.managepagination();
    }
    pageNavigateTo(num: number) {
        this.isDirectSearch = false;
        this.pageIndex = num;
        this.getUsers();
        this.managepagination();
    }
    managepagination() {
        this.totalPages = Math.ceil(parseInt(this.totalcounter) / parseInt(this.selectPageLimit)); //parseInt($("#SELECTPAGES").val()));
        if (this.totalPages < 5) {
            this.visiblePaginationBtn = false;
            this.numbers = Array(this.totalPages).fill(0).map((x, i) => i);
        }
        else {
            this.visiblePaginationBtn = true;
            if (this.pageIndex == 2 || this.pageIndex == 1 || this.pageIndex == 0)//Selected Page Is 3,2,1
            {
            this.numbers = Array(5).fill(0).map((x, i) => i);
            }
            else if (this.pageIndex == this.totalPages - 3 || this.pageIndex == this.totalPages - 2 || this.pageIndex == this.totalPages - 1)//Selected Page Is 10,9,8
            {
            if (this.pageIndex == this.totalPages - 3) {
                var cnt = this.pageIndex - 2;
                for (let i = 0; i < 5; i++) {
                this.numbers[i] = cnt;
                cnt++;
                }
            }
            else if (this.pageIndex == this.totalPages - 2) {
                var cnt = this.pageIndex - 3;
                for (let i = 0; i < 5; i++) {
                this.numbers[i] = cnt;
                cnt++;
                }
            }
            else if (this.pageIndex == this.totalPages - 1) {
                var cnt = this.pageIndex - 4;
                for (let i = 0; i < 5; i++) {
                this.numbers[i] = cnt;
                cnt++;
                }
            }
            }
            else {
            var cnt = this.pageIndex - 2;
            for (let i = 0; i < 5; i++) {
                this.numbers[i] = cnt;
                cnt++;
            }
            }
        }
        if(this.pageIndex == 0)
        {
            this.isPreviousBtnEnable = false;
            this.isNextBtnEnable = true;
        }
        else if(this.pageIndex == this.totalPages-1)
        {
            this.isPreviousBtnEnable = true;
            this.isNextBtnEnable = false;
        }
        else
        {
            this.isPreviousBtnEnable = true;
            this.isNextBtnEnable = true;
        }
    }

    getUsers() {
        this.progressPer = "90%";
        if(this.isDirectSearch == true)
        {
            this.fillingstationService.allsearchingData(this.pageIndex * parseInt(this.selectPageLimit), parseInt(this.selectPageLimit), this.searchFillingStationContent).then(data => {
                this.progressPer = "100%";
                this.fillingstationList = data;
                this.progressTimeOut();
            });
        }
        else
        {
            this.fillingstationService.allData(this.pageIndex * parseInt(this.selectPageLimit), parseInt(this.selectPageLimit), this.filterstatus,this.filtercountrycode, this.filterarea).then(data => {
                this.progressPer = "100%";
                this.fillingstationList = data;
                this.progressTimeOut();
            });
        }
    }
    progressTimeOut()
    {
        setTimeout(()=>
        { 
        this.progressPer = "0%"; 
        },200);
    }
    cancelAction() 
    {
        this.uniqueid = "";
        this.name = "";
        this.address = "";
        this.latitude = null;
        this.longitude = null;
        this.message = "";
        this.status = "Active";
        this.selectCountryCode = "";
        this.selectAreaId = "";
    }
    saveFillingStation() {
        if (this.uniqueid == undefined || this.uniqueid == "" || this.uniqueid == null) 
        {
            $.notify({
                message: "Please Enter Unique Id"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.name == undefined || this.name == "" || this.name == null) 
        {
            $.notify({
                message: "Please Enter Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.address == undefined || this.address == "" || this.address == null) 
        {
            $.notify({
                message: "Please Enter Address"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.latitude == undefined || this.latitude == null) 
        {
            $.notify({
                message: "Please Enter Latitude"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.longitude == undefined || this.longitude == null) 
        {
            $.notify({
                message: "Please Enter Longitude"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.status == undefined || this.status == "" || this.status == null) 
        {
            $.notify({
                message: "Please Select Status"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        let iFillingStation = {
            uniqueid : this.uniqueid,
            name: this.name,
            address: this.address,
            latitude: this.latitude.toString(),
            longitude: this.longitude.toString(),
            
            status : this.status,
            message : this.message
        }
        if(this.selectAreaId != "")
        {
            iFillingStation["areaid"] = this.selectAreaId;
        }
        this.fillingstationService
            .SaveFillingStation(iFillingStation)
            .then(data => {
                if (data.status == true) {
                    this.fillingstationList.splice(0, 0,data.data)
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.cancelAction();
                    $(function () 
                    {
                        $("#fillingstationaddModal").modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    showFillingStation(filling, i) {
        this.i = i;
        this.fillingstation = filling;
        this.id = filling.id;
        this.uniqueid = filling.uniqueid,
        this.name = filling.name;
        this.address = filling.address;
        this.latitude = filling.latitude;
        this.longitude = filling.longitude;
        this.status = filling.status;
        this.message = filling.message;

        if(filling.countrycode == "")
        {
            this.areaIUList = [];
            this.selectAreaId = "";
            this.selectCountryCode = "";
        }
        else
        {
            this.areaIUList = this.areaList.filter(word => word.countrycode == filling.countrycode);
            this.selectCountryCode = filling.countrycode;
            this.selectAreaId = filling.areaid;
        }
    }
    ExternalMapLocation(lati,longi)
    {
        window.open("https://maps.google.com/?q="+lati+","+longi, "_blank");
    }
    AddNewFillingStationClick()
    {
        this.cancelAction();
        this.selectAreaId = "";
        $(function () 
        {
            $('#fillingstationaddModal').modal('toggle');
        });
    }
    updateFillingStation() {
        if (this.uniqueid == undefined || this.uniqueid == "" || this.uniqueid == null) 
        {
            $.notify({
                message: "Please Enter Unique Id"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.name == undefined || this.name == "" || this.name == null) 
        {
            $.notify({
                message: "Please Enter Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.address == undefined || this.address == "" || this.address == null) 
        {
            $.notify({
                message: "Please Enter Address"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.latitude == undefined || this.latitude == null) 
        {
            $.notify({
                message: "Please Enter Latitude"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.longitude == undefined || this.longitude == null) 
        {
            $.notify({
                message: "Please Enter Longitude"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.status == undefined || this.status == "" || this.status == null) 
        {
            $.notify({
                message: "Please Select Status"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.status == "Maintenance" && (this.message == undefined || this.message == "" || this.message == null)) 
        {
            $.notify({
                message: "Please Enter Maintenance Message"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
         var uFillingStation = {
            olduniqueid : this.fillingstation.uniqueid,
            uniqueid : this.uniqueid,
            name: this.name,
            address: this.address,
            latitude: this.latitude.toString(),
            longitude: this.longitude.toString(),
            status : this.status,
            message : this.message
        }
        if(this.selectAreaId != "")
        {
            uFillingStation["areaid"] = this.selectAreaId;
        }
        this.fillingstationService
            .UpdateFillingStation(this.id, uFillingStation)
            .then(data => {
                if (data.status == true) {
                    this.fillingstationList[this.i] = data.data;
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    this.cancelAction()
                    $(function () {
                        $('#fillingstationupdateModal').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    onFilterStatusChange(filStatus)
    {
        this.searchFillingStationContent = "";
        this.filterstatus = filStatus;
        this.pageIndex = 0;
        this.isDirectSearch = false;
        this.getpaginationData();
    }
    onFilterCountryChange(filCountry)
    {
        this.searchFillingStationContent = "";
        if(filCountry == "All")
        {
            this.areabindList = this.areaList;
        }
        else
        {
            this.areabindList =  this.areaList.filter(word => word.countrycode == filCountry);
        }
        this.filterarea = "All";
        this.filtercountrycode = filCountry;
        this.pageIndex = 0;
        this.isDirectSearch = false;
        this.getpaginationData();
    }
    onFilterAreaChange(area)
    {
        this.searchFillingStationContent = "";
        this.filterarea = area;
        this.pageIndex = 0;
        this.isDirectSearch = false;
        this.getpaginationData();
    }
    onPaginationChange(pagelimit) {
        this.searchFillingStationContent = "";
        this.isDirectSearch = false;
        this.pageIndex = 0;
        this.selectPageLimit = pagelimit;
        this.getpaginationData();
      }
    getissueByStationId(filling,ind)
    {
        this.fillingS = filling;
        this.filterissuestatus = "All";
        var rrData = {
            isread : filling.isread,
            stationid : filling.id,
            status : this.filterissuestatus
        }
        this.fillingstationService
            .issueData(rrData)
            .then(data => {
                this.fillingstationissueList = data
                
                var cnt = 0;
                for (let index = 0; index < this.fillingstationissueList.length; index++) 
                {
                    const element = this.fillingstationissueList[index];
                    if(element.firstname == "" && element.lastname == "")
                    {
                        this.fillingstationissueList[index].name = "Anonymous";
                    }
                    else if(element.firstname != "" && element.lastname == "")
                    {
                        this.fillingstationissueList[index].name = element.firstname;
                    }
                    else if(element.firstname == "" && element.lastname != "")
                    {
                        this.fillingstationissueList[index].name = element.lastname;
                    }
                    else
                    {
                        this.fillingstationissueList[index].name = element.firstname + " "+element.lastname;
                    }
                    if(element.isresolve == true)
                    {
                        this.fillingstationissueList[index].isdisable = 1;
                        cnt++;
                    }
                    else
                    {
                        this.fillingstationissueList[index].isdisable = 0;
                    }
                }
                if(cnt == this.fillingstationissueList.length)
                {
                    this.isallselectDisable = 1;
                }
                else
                {
                    this.isallselectDisable = 0;
                }
                $(function () {
                    $('#fillingstationissueModal').modal('toggle');
                });
                this.fillingstationList[ind].isread = 1;
            });
    }
    selectAllChanged()
    {
        for (let index = 0; index < this.fillingstationissueList.length; index++) 
        {
            if(this.fillingstationissueList[index].isdisable == 0)
            {
                this.fillingstationissueList[index].isresolve = this.isallselect;
            }
        }
    }
    updateFillingStationIssue()
    {
        var _issueIDs = [];
        for (let index = 0; index < this.fillingstationissueList.length; index++) 
        {
          const element = this.fillingstationissueList[index];
          if(element.isresolve && element.isdisable == 0)
          {
            _issueIDs.push(element.id);
          }
        }
        if(_issueIDs.length == 0)
        {
              $.notify({
                message: "Please Select Atleast One Issue."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        this.fillingstationService.issueSolved(_issueIDs).then(data => 
          { 
              if(data.status)
              {
                this.isallselect = false;
                $(function () {
                  $('#fillingstationissueModal').modal('toggle');
                });
                $.notify({
                  message: "Status Successfully Changed."
                }, {
                  type: 'success',
                  placement: {
                      from: 'bottom',
                      align: 'left'
                  },
                  delay: 100,
                  timer: 100
                });
              }
              else
              {
                $.notify({
                  message: "Something wen't wrong.Please try again after sometime."
                }, {
                  type: 'danger',
                  placement: {
                      from: 'bottom',
                      align: 'left'
                  },
                  delay: 100,
                  timer: 100
                });
              }
          });
    }
    onIssueStatusChange(stat)
    {
        this.filterissuestatus = stat;
        this.isallselect = false;
        var rrData = {
            isread : this.fillingS.isread,
            stationid : this.fillingS.id,
            status : this.filterissuestatus
        }
        this.fillingstationService
            .issueData(rrData)
            .then(data => {
                this.fillingstationissueList = data
                
                var cnt = 0;
                for (let index = 0; index < this.fillingstationissueList.length; index++) 
                {
                    const element = this.fillingstationissueList[index];
                    if(element.firstname == "" && element.lastname == "")
                    {
                        this.fillingstationissueList[index].name = "Anonymous";
                    }
                    else if(element.firstname != "" && element.lastname == "")
                    {
                        this.fillingstationissueList[index].name = element.firstname;
                    }
                    else if(element.firstname == "" && element.lastname != "")
                    {
                        this.fillingstationissueList[index].name = element.lastname;
                    }
                    else
                    {
                        this.fillingstationissueList[index].name = element.firstname + " "+element.lastname;
                    }
                    if(element.isresolve == true)
                    {
                        this.fillingstationissueList[index].isdisable = 1;
                        cnt++;
                    }
                    else
                    {
                        this.fillingstationissueList[index].isdisable = 0;
                    }
                }
                if(cnt == this.fillingstationissueList.length)
                {
                    this.isallselectDisable = 1;
                }
                else
                {
                    this.isallselectDisable = 0;
                }
            });
    }
    onIUCountryChange(cCode)
    {
        if(cCode == "")
        {
            this.areaIUList = [];
        }
        else
        {
            this.areaIUList = this.areaList.filter(word => word.countrycode == cCode);
        }
        this.selectAreaId = "";
        this.selectCountryCode = cCode;
    }
    searchFillingStationList()
    {
        if (this.searchFillingStationContent == undefined || this.searchFillingStationContent == "" || this.searchFillingStationContent == null) 
        {
            $.notify({
                message: "Please Enter Search Text"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        if (this.searchFillingStationContent.length < 3) 
        {
            $.notify({
                message: "Please Enter Atleast 3 Character"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
            return;
        }
        this.isDirectSearch = true;
        this.progressPer = "15%";
        this.fillingstationService
            .searchfillingstationlist(this.searchFillingStationContent)
            .then(
                data => {
                    this.progressPer = "35%";
                    this.totalcounter = data.totalcounter;
                    this.managepagination();
                    this.getUsers();
                } 
            );
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstation/fillingstation.page.ts